/**
 * Fallback for forEach function
 *
 * @return {void}
 */
const init = () => {
	/**
	 * Fallback for forEach function
	 *
	 * @return {mixed} if foreach function exists, return false, else polyfill function
	 */
	const forEachUtility = () => {
		if ( 'function' === typeof NodeList.prototype.forEach ) {
			return false;
		}
		NodeList.prototype.forEach = Array.prototype.forEach;

		return true;
	};

	forEachUtility();
};

export default {init};
